﻿import { GradientPalette } from '@fe/weather';

function GradientBarHorizontal({ data }: { data: GradientPalette }) {
    const { name, suffix, units, minValue, maxValue, stops } = data;
    const svgWidth = 400;
    const svgHeight = 40;
    const gradientId = `gradient-${name?.replace(/\s/g, '')}`;
    const leftPadding = 15;

    return (
        <div className="legend-entry">
            <div>{name}</div>
            <div style={{ display: 'flex', alignItems: 'start' }}>
                {units && <span style={{ fontWeight: '500', fontSize: 14 }}>{units}</span>}
                <svg width={svgWidth + leftPadding} height={svgHeight} style={{ display: 'block' }}>
                    <defs>
                        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                            {stops.map((stop, index) => (
                                <stop
                                    key={index}
                                    offset={`${((stop.value - minValue) / (maxValue - minValue)) * 100}%`}
                                    stopColor={stop.color}
                                />
                            ))}
                        </linearGradient>
                    </defs>
                    <rect x={leftPadding} y={0} width={svgWidth} height={20} fill={`url(#${gradientId})`} />
                    {stops.map((stop, index) => (
                        <text
                            key={index}
                            x={`${leftPadding + ((stop.value - minValue) / (maxValue - minValue)) * svgWidth}`}
                            y={35}
                            fontSize="12px"
                            textAnchor="middle"
                            fill={'var(--text-color)'}>
                            {stop.value}
                            {suffix}
                        </text>
                    ))}
                </svg>
            </div>
        </div>
    );
}

export default GradientBarHorizontal;
